import { api, ApiError } from "@/api/api";
import { StoryConfig } from "@/api/story-configs-types";
import { useQuery } from "@tanstack/react-query";

export function useStoryConfigs() {
  return useQuery<{ items: StoryConfig[] }, ApiError>({
    queryKey: ["GET", "storyConfigs"],
    queryFn: api.storyConfigs.get,
  });
}
